var _style, _line, _defs, _defs2, _path, _path2, _path3, _path4, _path5, _rect, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34, _defs35;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorRobot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 264.6 176",
    style: {
      enableBackground: "new 0 0 264.6 176"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#6DB6B0;stroke-width:2.1344;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000049902150857772869610000013854872777485962627_);fill:none;stroke:#7FCDC4;stroke-width:4.2687;stroke-miterlimit:5;}\n\t.st2{clip-path:url(#SVGID_00000090266673944520229400000015326660605440560264_);}\n\t.st3{fill:#CEDC28;}\n\t.st4{fill:none;}\n\t.st5{enable-background:new    ;}\n\t.st6{clip-path:url(#SVGID_00000182486618727315382460000011666678973547063171_);}\n\t.st7{clip-path:url(#SVGID_00000149377929107610686890000009989493761845010876_);}\n\t.st8{clip-path:url(#SVGID_00000156571748351182150590000007518582317706402207_);fill:#55BBB1;}\n\t.st9{clip-path:url(#SVGID_00000111193654293640805830000008697289372542818202_);}\n\t.st10{clip-path:url(#SVGID_00000062185602494817132760000002913058990566147244_);fill:#55BBB1;}\n\t.st11{clip-path:url(#SVGID_00000155145434842623753660000006901803486832775862_);}\n\t.st12{clip-path:url(#SVGID_00000073691658488504965860000003934229272496526720_);fill:#55BBB1;}\n\t.st13{clip-path:url(#SVGID_00000140713117176066761550000007635469080599206325_);}\n\t.st14{clip-path:url(#SVGID_00000020367930961143791140000014457837722782155171_);fill:#55BBB1;}\n\t.st15{clip-path:url(#SVGID_00000176013427824650942730000000139736662798749828_);}\n\t.st16{clip-path:url(#SVGID_00000085208367641697973700000010346837695076140416_);fill:#55BBB1;}\n\t.st17{clip-path:url(#SVGID_00000163785077892918835670000010355322791045079711_);}\n\t.st18{clip-path:url(#SVGID_00000039118951350851163990000000606754849125001649_);fill:#55BBB1;}\n\t.st19{clip-path:url(#SVGID_00000063629944028554236990000018043430124551184782_);}\n\t.st20{clip-path:url(#SVGID_00000105417738284417212050000003920302010640705938_);fill:#55BBB1;}\n\t.st21{clip-path:url(#SVGID_00000180360166237647699760000013798480251949095583_);}\n\t.st22{clip-path:url(#SVGID_00000161589950134833673690000008139710795248547461_);fill:#55BBB1;}\n\t.st23{clip-path:url(#SVGID_00000041282012956521602020000006868049211808651443_);}\n\t.st24{clip-path:url(#SVGID_00000181050365559438480170000004144400766574371237_);fill:#55BBB1;}\n\t.st25{clip-path:url(#SVGID_00000021819780261075956920000004058120302315603133_);}\n\t.st26{clip-path:url(#SVGID_00000060725001866558866000000018087796039709592473_);fill:#55BBB1;}\n\t.st27{clip-path:url(#SVGID_00000145766446113619761990000013685497016965597611_);}\n\t.st28{clip-path:url(#SVGID_00000110437972206539095000000006336819466825357980_);fill:#55BBB1;}\n\t.st29{clip-path:url(#SVGID_00000169538668030525252530000018219785519776874427_);}\n\t.st30{clip-path:url(#SVGID_00000124879384270186062830000013096087341407597703_);fill:#55BBB1;}\n\t.st31{clip-path:url(#SVGID_00000160891532671878206510000014663810149625566864_);}\n\t.st32{clip-path:url(#SVGID_00000116941003345989426200000007756785210122948743_);fill:#55BBB1;}\n\t.st33{clip-path:url(#SVGID_00000150786641716903320040000015294429110932087982_);}\n\t.st34{clip-path:url(#SVGID_00000008134992044386091990000016618176615727582377_);fill:#55BBB1;}\n\t.st35{clip-path:url(#SVGID_00000069371385458926190690000011811788727458166945_);}\n\t.st36{clip-path:url(#SVGID_00000070808669715955057260000001973469298280524702_);fill:#55BBB1;}\n\t.st37{clip-path:url(#SVGID_00000011723290625406551850000008363446145944404906_);}\n\t.st38{clip-path:url(#SVGID_00000145743618453039240200000005960922338546678183_);fill:#55BBB1;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 116.4,
    y1: 114.5,
    x2: 82.3,
    y2: 114.1
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M135.8,95.6h86c11,0,20,9,20,20s-9,20-20,20h-86c-11,0-20-9-20-20S124.7,95.6,135.8,95.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139984021905502248650000001875338068795340974_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000139984021905502248650000001875338068795340974_)",
      fill: "none",
      stroke: "#7FCDC4",
      strokeWidth: 4.2687,
      strokeMiterlimit: 5
    },
    d: " M135.8,95.6h86c11,0,20,9,20,20s-9,20-20,20h-86c-11,0-20-9-20-20S124.7,95.6,135.8,95.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000088842546852344501860000004045995134978507677_",
    x: 116.8,
    y: 99.6,
    width: 125,
    height: 37
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104696477803745356810000009952659959939360398_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088842546852344501860000004045995134978507677_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000104696477803745356810000009952659959939360398_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M149.2,109.8c-0.1,0.1-0.1,0.1-0.2,0.1h-7.8c-0.1,0-0.1,0-0.1,0.1v3.7c0,0.1,0,0.1,0.1,0.1h5.1 c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2v2.3c0,0.1,0,0.1-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.1h-5.1c-0.1,0-0.1,0-0.1,0.1v3.8 c0,0.1,0,0.1,0.1,0.1h7.8c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2v2.3c0,0.1,0,0.1-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.1h-10.9 c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2v-16c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1H149c0.1,0,0.1,0,0.2,0.1 c0.1,0.1,0.1,0.1,0.1,0.2v2.3C149.3,109.7,149.2,109.8,149.2,109.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M163.1,123.4l-3-6.5c0-0.1-0.1-0.1-0.1-0.1h-2.2c-0.1,0-0.1,0-0.1,0.1v6.5c0,0.1,0,0.1-0.1,0.2 c-0.1,0.1-0.1,0.1-0.2,0.1h-2.8c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2v-16c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1 h6.8c1,0,1.9,0.2,2.7,0.6s1.4,1,1.8,1.7c0.4,0.8,0.6,1.6,0.6,2.6c0,1.1-0.3,2-0.8,2.8c-0.5,0.8-1.3,1.3-2.2,1.6 c-0.1,0-0.1,0.1-0.1,0.2l3.2,6.7c0,0.1,0,0.1,0,0.1c0,0.1-0.1,0.2-0.3,0.2h-2.9C163.3,123.6,163.2,123.5,163.1,123.4z M157.7,110 v4c0,0.1,0,0.1,0.1,0.1h3.1c0.7,0,1.2-0.2,1.6-0.6c0.4-0.4,0.6-0.9,0.6-1.5s-0.2-1.1-0.6-1.5c-0.4-0.4-1-0.6-1.6-0.6h-3.1 C157.7,109.9,157.7,109.9,157.7,110z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M180.4,123.4l-3-6.5c0-0.1-0.1-0.1-0.1-0.1h-2.2c-0.1,0-0.1,0-0.1,0.1v6.5c0,0.1,0,0.1-0.1,0.2 c-0.1,0.1-0.1,0.1-0.2,0.1h-2.8c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2v-16c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1 h6.8c1,0,1.9,0.2,2.7,0.6s1.4,1,1.8,1.7c0.4,0.8,0.6,1.6,0.6,2.6c0,1.1-0.3,2-0.8,2.8c-0.5,0.8-1.3,1.3-2.2,1.6 c-0.1,0-0.1,0.1-0.1,0.2l3.2,6.7c0,0.1,0,0.1,0,0.1c0,0.1-0.1,0.2-0.3,0.2h-2.9C180.5,123.6,180.4,123.5,180.4,123.4z M175,110v4 c0,0.1,0,0.1,0.1,0.1h3.1c0.7,0,1.2-0.2,1.6-0.6c0.4-0.4,0.6-0.9,0.6-1.5s-0.2-1.1-0.6-1.5c-0.4-0.4-1-0.6-1.6-0.6h-3.1 C175,109.9,175,109.9,175,110z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M191.5,123.1c-0.9-0.5-1.7-1.2-2.2-2.1c-0.5-0.9-0.8-1.9-0.8-3.1v-5.1c0-1.2,0.3-2.2,0.8-3.1 c0.5-0.9,1.2-1.6,2.2-2.1c0.9-0.5,2-0.7,3.2-0.7c1.2,0,2.3,0.2,3.3,0.7c0.9,0.5,1.7,1.2,2.2,2.1c0.5,0.9,0.8,1.9,0.8,3.1v5.1 c0,1.2-0.3,2.2-0.8,3.1c-0.5,0.9-1.2,1.6-2.2,2.1c-0.9,0.5-2,0.7-3.3,0.7C193.5,123.8,192.5,123.6,191.5,123.1z M196.9,120.2 c0.5-0.6,0.8-1.3,0.8-2.2v-5.2c0-0.9-0.3-1.6-0.8-2.2c-0.5-0.6-1.2-0.8-2.1-0.8c-0.9,0-1.6,0.3-2.1,0.8c-0.5,0.6-0.8,1.3-0.8,2.2 v5.2c0,0.9,0.3,1.6,0.8,2.2c0.5,0.6,1.2,0.8,2.1,0.8C195.6,121,196.3,120.7,196.9,120.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M215.1,123.4l-3-6.5c0-0.1-0.1-0.1-0.1-0.1h-2.2c-0.1,0-0.1,0-0.1,0.1v6.5c0,0.1,0,0.1-0.1,0.2 c-0.1,0.1-0.1,0.1-0.2,0.1h-2.8c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2v-16c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1 h6.8c1,0,1.9,0.2,2.7,0.6s1.4,1,1.8,1.7c0.4,0.8,0.6,1.6,0.6,2.6c0,1.1-0.3,2-0.8,2.8c-0.5,0.8-1.3,1.3-2.2,1.6 c-0.1,0-0.1,0.1-0.1,0.2l3.2,6.7c0,0.1,0,0.1,0,0.1c0,0.1-0.1,0.2-0.3,0.2h-2.9C215.3,123.6,215.1,123.5,215.1,123.4z M209.7,110 v4c0,0.1,0,0.1,0.1,0.1h3.1c0.7,0,1.2-0.2,1.6-0.6c0.4-0.4,0.6-0.9,0.6-1.5s-0.2-1.1-0.6-1.5c-0.4-0.4-1-0.6-1.6-0.6h-3.1 C209.7,109.9,209.7,109.9,209.7,110z"
  })))), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 160,
    height: 159,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKEAAACgCAYAAABkDQwTAAAACXBIWXMAAAsSAAALEgHS3X78AAAU XklEQVR4nO1dW47stg7kObh7ykf2lMVkT/nIpmbuR+CBml1FFimpp+1xAYZliXpYKpGU7Hab3bhx 48ZPx6/vbsCN9fjr33/Ccf37jz8/X9UWBTcJT4qMaDN4NUlvEp4EO0kX4RWEvEl4AkwS8Mg7Raad ZLxJ+MYokG92HCWC7SLiTcI3hUDAKF0ZV0aolGiryXiT8M3QJB/L4+Mj8qA0Kr+SiDcJ3wCi2fUy 2XUFnlDZ9QNmCXmT8MUoLjKqxKuOZ6b9StpxRIWYNwlfgBcSb5aE0fU2Qt4k3IjJ1W1ELpa2ioRV 8zxFxpuEm9D083wcI98qEpphbcc04DQZERFvEm7AghVuRr5XacItZPREvEm4GA0CdshXIeEYF/l1 qkZUicnizOyRiL+Z0I0tiEjmyRQdSOY3uEZxrMwoDdXn2+3vAd3vF8bJ+j8mdKOORAsq2qui+SIZ VLbZf5oJEUXdTjnyj+exHh8vlX9rwtdAIZ1y/CZnJIfSUHynfqQV0f2ge/7CMWlvTbgfkRZDcZ4c lbMPZ21CmsuGOJ+GNKmB9FFDovADbhIuAjHFCgEjYmWapUtCs0dCMdKZS4/KYaY6xU3CfagSUNWI ijZV21d95jvmQVoxIySsc5qEV3rN/IWICFghpAVxK9rY6f8SEf/6959fZRK+8jXzsa4TE1I1s8jZ r/iJPjyLgzyKifZaEa2O533CCfJljmyp/pOQUSVMRsAV5BsXISwtQrYYieSksZJIuPE183KjT0ZG hIhsmZY0cDZyjeplUImW5fEacJSjC5d0n1B8DDV2UpSOOrtSVqVd34VIc/l7i/pG0Y4WpHfKzcpA bVDHliLUhItfNVfys5l0NWQDl5liFndce61jxjUXGq+KZlTMfOgT0ooKj6BYOTM3Ib+V8Q5m2fVV Zk5/u7iKlvLl+7gZRC8rjGcfVg9WTuuxXUTAjqnNTAyq8wtvbJYRKmbTSLhjRjt1Re01kicad9YX mITBwKoNUG+4Qr4zEVFtT3R/FXM8e/+Rpo3GleWPFM4TKvuECjlQw5FMZEKRH5M+f9xNxAmzv0Lb obMP+2vWXiaD+tyfmazPV8ITCQvPQMdwpaOOOOYLItJJRNwJ1C+AmJLmXoRMyyj1jwQa4yIisrEY 032ZTNbM5h7bsZk8nn04Kisj5QwRq4SQyl70jZhMS0ZnFo7ajzQh0nSzLyb4vqH5FBJmmk8lIyp3 9mG4Gb65WS0kd2CzbqV/WHksT0cLd02pJ3I174NsxyfMfBkm66HMsIp/orS9AlbHrCtQJUiUL+vn bIIqbk82Rh0t+YCMhOqsQyTs+kdeK0ZmgkFpN6sbySqb6Iwkvm9WQZnoWZ0R6ZQ8rL4SGVVNyHyR yJfJTE50M8w8j/nYjEbtVhHVOV6P7VDK6bZB9Q3ZhEerVwvSUVumtJyCzsIkIh27zspjppjJZSZ5 loyI1GjAZknu0yrlVTUhS0cTLTO9Sttk0nb3CVE8ImDFV8nAFiZjGmsbakNWz3h95M9W56tN7lhm pPUyq6MgWylvQ0RCxZxGGjAi4XhjjEAR2TJ/LDNTKpg5y8zYbjAidjQ+m1wZGZeR84GEzde2mG+o muRfZvZh3MSyhQlK8+GOhkCdiwiY+aEzWimzOlF4jMtIohKwii0LEwaFjF7O5/+0/55hfwznTv0+ rjJgZnOO+aqFEYNKymr9zM/tEnDLFs2BbLAjMrL8Zo+d4LVcB2xQssFhfqCyT+nzIi0c3ZNCsCi+ Y4bHvMp2DLMOCGUidjUhI2Ul/sCnIFNtFyOgMrBeO0R+aLZFo/qk1XuPlEIX3+bjdrdofFg1ywy7 NaDqp0Xm6TgrZIxcgVUTLoJSfrbIqJplVfZJrkrC7OYqPskOfynShFHbIue8u19W1cBVrCpzxgc0 4320ZZ+wiowEmfaLNqNRPUe4QkRfBjK9nozVQVP90igvk9/lD84Qc+yrT3eMMl/YQULUMawDM6dY rc+fM98wKostQpBmZA47u/8OaSoadbeZ9/DE2ro6XgVmAmfLi3xSlI7AfMCZdmVxq8peiVnzrOKr joffmAivsCuNy1aM47XXENGi5gj/ttr393x6lKaW6eNYmE0GH+/7o4tZ8lTqp+ZVzPMFVRMqj6+6 YDNP0VijbDbQlXbu8pdQOxT3pUoORb67mFAUFfMFn/D3H39+RiT0vlFWMfKnEDyBmVlGG9lITvUJ Ud4qEAGZX4jaOIYV/05tO9ts3wWmBZUN7OktmrGgzoD6Tl2hVTMSonOlbOWJAgqb8XtibkgHFWXB 8kfXY3wk2yb+zMJkpSlGg6aavQr5ZjS6b4/Svqg+ZoZnTC8aE7bVVSFQZrqntGFGwo4prkLNy0wh Oh/hqgasyKGtm4q/yMyuj1P9u3EiR3Isju3vZeWgsLQ/eGB2iwYRUCVl5OeN5TCTN+aLfK7IHPr6 fNvQmRHNy2aI3AgFqH1dRERhCw2JYAqqJIxIc6QrHekHwJMsMzG+HBZmixhWVkZE356IkEbSWHu7 fqtvUzUfC6u+IdOgMkE7WzT+epVvqJSF0jMizraro+VNlOn4rqzvu5ooIl+mBZlWZGU/xB370hVN 2CEIAupor2GrxFZlZ0wWqseb6Mh1yMqLXIsIbOGB0rNyMlObacGsfRBPX+UqfPgnUtkZmCOO/KNf woHK2gm1ndkTHFRGVN+BSPMwk8iAtBqqh2lBliZz45XPjpUFAtOASFNG5a5wETwUd4TVG2lFlXgI mY8+yijpjEyMeBWi07a8ioTqrM8WJEqne9kdqLgNlTZX5FAdXdlI20VkVNIhRourfhpOQceHU1bZ ERk7qGqkCOoqfgaKn9dZnHhZlVyqBkTEhpj58Xt15XeElRVgZOp8XIZo5o/1Ibkdi6MMygJQiVPS xnS2MFlNzifM/NoOxXe2T1QfkK1AR/kxjGY6Q6ZZVH8WIdL2FXkV1YnJTDGTG2UifxGdzex58dv9 jUlEImXAlHimmTwRERQiMoL5shHpEVTfMJJXtZYim5WNSMXCqqZrta/zabjd2x9jPZ8gHAHN4kxL MvNXWXwoUDSn6mbM+n4+jEjnr1UzXLFAZlb/DAiD35ur7n2tXHiM+bPzKK9q5RVbKl5e8VHVPlF8 RjYZuySMyn0A2ode+RmQ4zozWVVnP9OG2Sz2Mj4fKtubfXURloERD91bdr8+HMlF+Wa0YNYOaeLM fJXLy3VR3dxVEBHQn7MV98z9RRoeLX5WmVkWv8oUm5Nh5T2APY3rfKl1PMzFI3kf90ooHcQ0ULQ1 pECdXBVt768rsizMiOevmenO2pNixUcymcwM6RSydMvqlIOIWCXlAaRxKwsvH840Yqb9/DkiIItj 9XwheieBkXDGFFf9xO5gzmLUPpHMrrZ1XQ5FAynE83FVzZjV94XspZiVf6YzowWzwagOliI/Q4JV xKy0AQ18xd9jcpmZjQiYaWEJ1T/TQddqWhWRv8PMCNISlfK7WEHMij+omsMKMVWtqJT3BeXVwOpf zXozPbNyjhpX8WMqqBI7KyfTKgoq5GWaR/XjPoI0RQuyeiHUd1Mrq+POTEcaYoxTtJU6q1lnonrQ NdobZO1jMmyl25mMmQmtaMPKpGYkZPl9uAxln3AF/ECp8hGZmExUFjpnWzFKB0eTim3LePlISx9h JhOZ1kguklEIztpd+mveV7zUmmlDHz+G1Zk+yqsdqbal+qKBsr9Y0RxIa2f3qpLSh19OQLPXfxrO LDd1FXMx5mGDMtNG36YR2coWmWxmBbLJ4u/N7PleFXNaJWHWpid0/px8Fwmj2R89fYgIV5mN6Wwl 9SOMbWX3gOKRJmT3zeqNzG9Ewq5GY0RT+rNFQLN1X2BA18rsj3ypqFNROCKbbwvTbCjM2sv8x+wR H9OyihaMrICXzcqOiFUyv2Z9AprVf3dsFvs5kWOPtEFXi0kdM0CdGNXtEpVwinn3+VicJ2VEQgPp Sh0ofQsBzWISMjOCzE2kEVmZrM7xzOJ8mkfkCqjoENKHZ6CaXcUUV/qw0s/TBDRb6xN6MkYmj2lS tZ4qdj3/jchXIWNEkiNeNcsRCbM6lLgvrCCg2b6vcplpJoqlm+GOK/sqGxCRjfVHtEJGmggRbpTt akR0LwgvId8BhYSRdstWiQjK6ni8zjpTIWP3aU+WlpngisZnpKscUTlR3VnaF1YT0Gz+g0jjLGcE ZIuUrEOymat2RtcUozYiLTjKdrdmGPnQtaIBK1ZEwg7yHWAkRB3JgDrfDGvPysbtGI60XxSXbbtk 9atgBESTLtue6Rw+Lyq7dW87yXeg+n3CzIdQTSMz61FexaT4MlE4ascom91zBchlMXddJZwvIyKg fA+vIJ3HqtUxGrDoZpgvOYY7pItIxYjowUxsBmY9FAvBNFoWHxEUtvk7SJah8j8mqjaMtmhUdPN6 UiECZm5A9lREBcunTjhEMC/r01g7zOw9CWg2/xcSZpr5ykxw9jSh03megBmRosdvSv3KJjxLq5rk yKSj81sj+2875eaUDvsIZH08qt9rsl8urBw+fybjz2r5KiqE6xDyNOhs0UTaIZvxaPsGEQ2Bbf2w fBVT3AHT+JV8bDJmkxbVf1oyVjerFVmGD+Nag5Ex2nOM4sb4XSSsIvLrxvBx/WGYhD4POj/hXf1B s97/mFR9JRVsY1chTkTOLgmzRVilrAoBq2aYuUingfr1ftaJx3nWn2EdG6HiD3b8SFU2AzO/Uf8h c8zKY3GnQfex3WqNiLZCmLZhmk3Vhlk7orp9GmozA9NelYnJwmH972yKzcjvjoNGZ7NwTFM7mHWu B9JQPjxedzUgy5eVby48IjLHVUtxaq2H0NknZJpg7BAW9+nymJOr+H/R4DMNmJWvtmOUYxYC5VlF QFb+E95dC5olnZ18udUPNNM4ZvG/GmUaK6uL3UfVFHsoAx5pOBQ3c7CyWRtPQUCz5DMgyU2gjj7O ivllHc2gEJCRt4Nsoqjls/vzJMr6JCP8A85CQDPhWzRFIqJ01Zx0wPw2A9cob4ewFW3sUfGBfR6z df32VpA1RWCaVbNcOUbz7cuK6szuSSVKFq9YAX89HscWTLYhnZn4J5xJAx6Qv8olrJiZ71QxuShf FZnmnnEJZtHRaqnvd+CMBDQrfhpOvMmqiY5kUT5FfiWhVpQ1a3az69MS0Kz+fULVR6xAIZaihVVN XD2ytkTEyciH8lb8RTM7NwHNGiQ0C1/5mkWlnIx0q+HLVQjKykHnH4sWCb8Z6gTYaY5XW4MfjVUk XLEvx/DOg9ppW2dr59JokXDiP/AQor0+j6rWW7Gg6MYpQPcebY5fEju+T5h1ZqWTP4c0FD4GHz2v HWVnkJFupW/Hnjv79EzuVFhBQnW2rprN4yAgojHyqfXPrtKzMsb2rJQ7LXYtTNSnFpFcpG2ibQy2 Qu5syahpvr3o+kBmGZClMAv6arF79HKsNsfsZQJmln1YgaoJffwsIrOcbd2YrXMPLmeSyyR0s26l 4+zJg/y/mYGsEl2NVzR21iZ0b769lyAcwkpNGC1IzHraj834DhnZ4Pr0LH+WFrkODH6RxeQvo/1G vOIvJGTfxkFZAft6LJBRiVt56sHiKhqwg0uZ5JWr4915M5OVrYa7g1UhbeXJygGkBY+86B4uQbwR K/5qdgxne4NRXgQ/EOiatam7RYPyZvFZ2lF/xb24HNkYdj879gMfrZCZfHSttqGaj+VRt55YHPOR Ozj1tsyI7/hbMQ9EQIV82SCsXLGzLSBz6ZE8ksnayEzypTBLwsgkj+Ho8HlZ+eg6as9KVBc9yC1Q V8C+3MuRzmO1Oe6sghERo+0dL4PkI5nqoZaptL3qnjA8pZ/5qcl3vU/IBpnJseso3yp062TXmfvR 8V9PjRUkVGdtNJhdvxCVs9skV2TuhYeAVy1MlJle0QxVU8+ePrA0ls7qrSxEKnt9SP5yfuI7vN4f aY8uAWc1YtUFmGnnj8c7kLCClQOLXs8a06pQibhyxX8JEr8zCXdpny5mCXUJwuzAO5PQA5npnQuR rC3t7RSHFS9UnBqvIqHakdF+GgqPcau3ZVh8phF3T4rK2zqnwAoSqh2hvujpsWKAK/lW1FHxS5X0 S5CN4RWacMfMVTe7d4I9HZnFjyDeiO/yCRkxlZdW1XhW30rZDtgLsdGPpi6N1ST8BEcmy9KiuHGw dgxY5e3qqjsShVVciqSzT0z8285IK2VPJEaZ8QlBVkd1VVldHFWflHTC6iSNJvXpCfmd7xOyR13+ EZXZM0l9WK1npl0IqA2ZxmbkYhbk9CTLsPpPt49whuwZqo+PyLiDiMq9RG3w8Ugu09Q/Zv9wtSZk JpnJdR7OZzI7TRZyIdA1M7uRBvTxSA7Va2bn/lDm7J9uIx9uTO+g85bIaq2R3VN2v0zzKWZ412Lr bbFSEzJ/zqzWqYgAVXPfqVdph1JuZJojDYfKYf7hpUi6wycc4w5UFhHKyjgroxLvwSZP5ylI5Bsq mhGVyeo6LVZu0YzXSHMxIkYEZmUp7arEH1AXSpX6M5M8hhH5osXNJbDLHLPFRjSYkY852/Ed8nbd CVYe04ZjGKUpZZ8aK0io+E7VFXDkX2b5OmkjlL3BSjuQj8iIGMVFbTo1Wg/cwc8L2bt+Yxx7B5C9 BLDj5QRlEFfXW/ERMxlU5qm3Z8z2bVarvtwhx/KbzZOiOkCdxYhSb0QmZoZPTS4VO3zCMRyRq1LW iM62SRdVk8wWXixO1XaXJubOZ8fRAmW23O/GjHaNNKEafyms+luxA1Gnoa2H6FD+hvXdjw/xPny/ ZH15KezQhN6XQ5qw8jrWd749PYuqeVavv3D2RYnZ5AALH+HJfhSktOFqJIzSStrvCgQ0m3yzWugE b25QHDNNLP1MR3QfKN7L/wgs0TKFz5LN/E6kgp17fbvLk+q6ihY0WzhYje/jndnMrkSJTFci34Et RNjwwcYzEnYpWa5IvgMvGdwzf0X0O3BlwiH8HxBZBqqyG5UGAAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 10.7914 7.5773)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.8,
    y: 7.6,
    className: "st4",
    width: 160,
    height: 159
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000151516916805279743660000012151804584975772825_",
    x: 27.8,
    y: 24.6,
    width: 126,
    height: 125
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054258795393097176170000010543161517851119250_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000151516916805279743660000012151804584975772825_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054258795393097176170000010543161517851119250_)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000098220647076066257640000012101588108800537275_",
    d: "M112,37.2v10.8c0,12.3,7.2,23.8,18.9,30.1 c11.7-6.3,18.9-17.7,18.9-30.1l0-10.8c-3.5,0.1-7-0.6-10.3-2c-3.3-1.4-6.2-3.4-8.7-5.9c-2.5,2.5-5.4,4.5-8.7,5.9 C119.1,36.6,115.6,37.2,112,37.2L112,37.2z M131,82c-0.3,0-0.6-0.1-0.9-0.2C116.6,75,108.3,62,108.3,47.9V35.3 c0-0.5,0.2-1,0.6-1.3c0.4-0.4,0.8-0.6,1.3-0.6c6.6,0,13.5-1,19.4-8.1c0.4-0.4,0.9-0.7,1.5-0.7s1.1,0.3,1.5,0.7 c5.9,7.2,12.8,8.1,19.4,8.1h0c0.5,0,1,0.2,1.3,0.6c0.4,0.4,0.6,0.8,0.6,1.3v12.6c0,14.1-8.4,27-21.9,33.9 C131.6,82,131.3,82,131,82L131,82z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000095336115376724220660000005683341186592721562_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098220647076066257640000012101588108800537275_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000095336115376724220660000005683341186592721562_)"
    }
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000015323992127013786010000014587709668403648665_",
    x: 11.8,
    y: 7.6,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121251877996679680750000013796268368536774286_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000015323992127013786010000014587709668403648665_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 107.3,
    y: 23.6,
    style: {
      clipPath: "url(#SVGID_00000121251877996679680750000013796268368536774286_)",
      fill: "#55BBB1"
    },
    width: 47.5,
    height: 59.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054258795393097176170000010543161517851119250_)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000163772297900546136650000002728330227605063101_",
    d: "M48.8,69.1c-0.7,0-1.5,0.3-2,0.8 c-0.5,0.5-0.8,1.2-0.8,2v31.4c0,0.8,0.3,1.5,0.8,2c0.5,0.5,1.3,0.8,2,0.8h48.3c0.8,0,1.5-0.3,2-0.8s0.8-1.3,0.8-2V71.9 c0-0.8-0.3-1.5-0.8-2c-0.5-0.5-1.3-0.8-2-0.8L48.8,69.1z M97.1,109.9H48.8c-1.8,0-3.4-0.7-4.7-1.9c-1.2-1.2-1.9-2.9-1.9-4.7 V71.9c0-1.8,0.7-3.4,1.9-4.7c1.2-1.2,2.9-1.9,4.7-1.9h48.3c1.8,0,3.4,0.7,4.7,1.9c1.2,1.2,1.9,2.9,1.9,4.7v31.4 c0,1.8-0.7,3.4-1.9,4.7C100.6,109.2,98.9,109.9,97.1,109.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031183679937790673050000005053320814884106666_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163772297900546136650000002728330227605063101_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000031183679937790673050000005053320814884106666_)"
    }
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000176752021892514104330000001593186474797469353_",
    x: 11.8,
    y: 7.6,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000164491757618571412360000006438260246083301547_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176752021892514104330000001593186474797469353_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.2,
    y: 64.3,
    style: {
      clipPath: "url(#SVGID_00000164491757618571412360000006438260246083301547_)",
      fill: "#55BBB1"
    },
    width: 63.6,
    height: 46.6
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054258795393097176170000010543161517851119250_)"
    }
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000046299129581515931760000015344608162439770508_",
    d: "M42.2,78.1c-3.4,0-6.6,1.8-8.3,4.8 c-1.7,3-1.7,6.6,0,9.6c1.7,3,4.9,4.8,8.3,4.8V78.1z M44.1,101h-1.9c-4.8,0-9.2-2.5-11.6-6.7c-2.4-4.1-2.4-9.2,0-13.4 c2.4-4.1,6.8-6.7,11.6-6.7h1.9c0.5,0,1,0.2,1.3,0.6c0.4,0.4,0.6,0.8,0.6,1.3v22.9c0,0.5-0.2,1-0.6,1.3 C45,100.8,44.6,101,44.1,101L44.1,101z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000068666095091154572940000015156164340170736560_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000046299129581515931760000015344608162439770508_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000068666095091154572940000015156164340170736560_)"
    }
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000067215009896391379520000012017217109314550439_",
    x: 11.8,
    y: 7.6,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000045576885608268733760000008392243760692916354_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067215009896391379520000012017217109314550439_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 27.2,
    y: 73.3,
    style: {
      clipPath: "url(#SVGID_00000045576885608268733760000008392243760692916354_)",
      fill: "#55BBB1"
    },
    width: 19.8,
    height: 28.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054258795393097176170000010543161517851119250_)"
    }
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000176044204936172289800000013606687376741241478_",
    d: "M103.8,97.2L103.8,97.2L103.8,97.2 c3.5,0,6.7-1.8,8.4-4.8c1.7-3,1.7-6.6,0-9.6c-1.7-3-4.9-4.8-8.3-4.8h-0.1V97.2z M103.8,101h-2c-0.5,0-1-0.2-1.3-0.6 c-0.4-0.4-0.6-0.8-0.6-1.3V76.2c0-0.5,0.2-1,0.6-1.3c0.4-0.4,0.8-0.6,1.3-0.6h2c4.8,0,9.2,2.5,11.6,6.7c2.4,4.1,2.4,9.2,0,13.4 C113,98.5,108.6,101,103.8,101L103.8,101z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137103222532324931660000009463591644363499139_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176044204936172289800000013606687376741241478_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137103222532324931660000009463591644363499139_)"
    }
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000131327553975450391170000009462935139293105024_",
    x: 11.8,
    y: 7.6,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157292012691763185060000016243351040930832789_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000131327553975450391170000009462935139293105024_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 73.3,
    style: {
      clipPath: "url(#SVGID_00000157292012691763185060000016243351040930832789_)",
      fill: "#55BBB1"
    },
    width: 19.9,
    height: 28.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054258795393097176170000010543161517851119250_)"
    }
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000155104551856191985510000009843456180034275238_",
    d: "M87.1,80.1c-0.8,0-1.5,0.3-2.1,0.9 c-0.6,0.6-0.9,1.3-0.9,2.1c0,0.8,0.3,1.5,0.9,2.1c0.6,0.6,1.3,0.9,2.1,0.9c0.8,0,1.5-0.3,2.1-0.9c0.6-0.6,0.9-1.3,0.9-2.1 c0-0.8-0.3-1.5-0.9-2.1C88.7,80.5,87.9,80.1,87.1,80.1L87.1,80.1z M87.1,89.8c-1.8,0-3.5-0.7-4.8-2c-1.3-1.3-2-3-2-4.8 c0-1.8,0.7-3.5,2-4.8c1.3-1.3,3-2,4.8-2c1.8,0,3.5,0.7,4.8,2c1.3,1.3,2,3,2,4.8c0,1.8-0.7,3.5-2,4.8 C90.6,89.1,88.9,89.8,87.1,89.8L87.1,89.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000046319359814407835720000009498510611247539879_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155104551856191985510000009843456180034275238_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000046319359814407835720000009498510611247539879_)"
    }
  }, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000025406960039674729690000000513444794764532649_",
    x: 11.8,
    y: 7.6,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000102519117210847095490000013984877205688160943_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000025406960039674729690000000513444794764532649_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 75.3,
    style: {
      clipPath: "url(#SVGID_00000102519117210847095490000013984877205688160943_)",
      fill: "#55BBB1"
    },
    width: 15.5,
    height: 15.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054258795393097176170000010543161517851119250_)"
    }
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000172421886288959260670000015574079597353130154_",
    d: "M58.8,80.1c-0.8,0-1.5,0.3-2.1,0.9 c-0.6,0.6-0.9,1.3-0.9,2.1c0,0.8,0.3,1.5,0.9,2.1c0.6,0.6,1.3,0.9,2.1,0.9c0.8,0,1.5-0.3,2.1-0.9c0.6-0.6,0.9-1.3,0.9-2.1 c0-0.8-0.3-1.5-0.9-2.1C60.3,80.4,59.6,80.1,58.8,80.1L58.8,80.1z M58.8,89.8c-1.8,0-3.5-0.7-4.8-2c-1.3-1.3-2-3-2-4.8 c0-1.8,0.7-3.5,2-4.8c1.3-1.3,3-2,4.8-2c1.8,0,3.5,0.7,4.8,2c1.3,1.3,2,3,2,4.8c0,1.8-0.7,3.5-2,4.8 C62.3,89.1,60.6,89.8,58.8,89.8L58.8,89.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000113328852693489096210000018310277541871111068_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000172421886288959260670000015574079597353130154_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000113328852693489096210000018310277541871111068_)"
    }
  }, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000145035785868078356430000008536640408378551175_",
    x: 11.8,
    y: 7.6,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152252245803111778120000008837254187442216376_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145035785868078356430000008536640408378551175_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 75.3,
    style: {
      clipPath: "url(#SVGID_00000152252245803111778120000008837254187442216376_)",
      fill: "#55BBB1"
    },
    width: 15.5,
    height: 15.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054258795393097176170000010543161517851119250_)"
    }
  }, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000149356098916970990920000013528756206493062293_",
    d: "M80.8,98.9H65.1c-0.7,0-1.3-0.4-1.6-0.9 c-0.3-0.6-0.3-1.3,0-1.9c0.3-0.6,1-0.9,1.6-0.9h15.8c0.7,0,1.3,0.4,1.6,0.9c0.3,0.6,0.3,1.3,0,1.9 C82.1,98.6,81.5,98.9,80.8,98.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000923808274496521310000005812862936250942848_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149356098916970990920000013528756206493062293_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000000923808274496521310000005812862936250942848_)"
    }
  }, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000008857559536638821740000012467899196981885618_",
    x: 11.8,
    y: 7.6,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067931594862226843770000017552412453432993448_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008857559536638821740000012467899196981885618_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 62.1,
    y: 94.1,
    style: {
      clipPath: "url(#SVGID_00000067931594862226843770000017552412453432993448_)",
      fill: "#55BBB1"
    },
    width: 21.7,
    height: 5.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054258795393097176170000010543161517851119250_)"
    }
  }, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000010280113110934885670000003609459503882289083_",
    d: "M84.4,69.1c-0.5,0-1-0.2-1.3-0.6 c-0.4-0.4-0.6-0.8-0.6-1.3c0-3.4-1.8-6.6-4.8-8.3c-3-1.7-6.6-1.7-9.5,0c-3,1.7-4.8,4.9-4.8,8.3c0,0.7-0.4,1.3-0.9,1.6 c-0.6,0.3-1.3,0.3-1.9,0c-0.6-0.3-0.9-1-0.9-1.6c0-4.8,2.5-9.2,6.7-11.5c4.1-2.4,9.2-2.4,13.3,0s6.7,6.8,6.7,11.5 c0,0.5-0.2,1-0.6,1.3C85.4,68.9,84.9,69.1,84.4,69.1L84.4,69.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000010999321596693397480000009915940709659469198_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000010280113110934885670000003609459503882289083_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000010999321596693397480000009915940709659469198_)"
    }
  }, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000001649638047513485370000005620671916211108787_",
    x: 11.8,
    y: 7.6,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038376325900276248410000011903417844392331445_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000001649638047513485370000005620671916211108787_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 58.6,
    y: 52.3,
    style: {
      clipPath: "url(#SVGID_00000038376325900276248410000011903417844392331445_)",
      fill: "#55BBB1"
    },
    width: 28.7,
    height: 17.9
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054258795393097176170000010543161517851119250_)"
    }
  }, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000106864943698385992550000018328722341004287392_",
    d: "M37,79.4c-0.5,0-1-0.2-1.3-0.6 c-0.4-0.4-0.6-0.8-0.6-1.3V57.7c0-0.7,0.4-1.3,0.9-1.6c0.6-0.3,1.3-0.3,1.9,0c0.6,0.3,0.9,1,0.9,1.6v19.8c0,0.5-0.2,1-0.6,1.3 C38,79.2,37.5,79.4,37,79.4L37,79.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098194377135594184360000017652254604903090871_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106864943698385992550000018328722341004287392_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000098194377135594184360000017652254604903090871_)"
    }
  }, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000039128847862707447060000003272038491294197387_",
    x: 11.8,
    y: 7.6,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000051347486017843020160000005088973862415622559_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039128847862707447060000003272038491294197387_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 34.1,
    y: 54.8,
    style: {
      clipPath: "url(#SVGID_00000051347486017843020160000005088973862415622559_)",
      fill: "#55BBB1"
    },
    width: 5.8,
    height: 25.6
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054258795393097176170000010543161517851119250_)"
    }
  }, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000177484156775718584610000010831744263135892617_",
    d: "M37,48.1c-1,0-2,0.4-2.7,1.1c-0.7,0.7-1.1,1.7-1.1,2.7 s0.4,2,1.1,2.7c0.7,0.7,1.7,1.1,2.7,1.1c1,0,2-0.4,2.7-1.1c0.7-0.7,1.1-1.7,1.1-2.7c0-1-0.4-2-1.1-2.7C39,48.5,38,48.1,37,48.1z  M37,59.7c-2,0-3.9-0.8-5.3-2.2c-1.4-1.4-2.2-3.3-2.2-5.3c0-2,0.8-3.9,2.2-5.4c1.4-1.4,3.3-2.2,5.3-2.3c2,0,3.9,0.8,5.4,2.2 c1.4,1.4,2.3,3.3,2.3,5.3c0,2-0.8,4-2.2,5.4C41,58.8,39,59.7,37,59.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101089617703493593930000007222649699287273610_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000177484156775718584610000010831744263135892617_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000101089617703493593930000007222649699287273610_)"
    }
  }, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000179639143372409666730000014382682178406584749_",
    x: 11.8,
    y: 7.6,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000007418067729161694790000012389058631706313890_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179639143372409666730000014382682178406584749_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 28.4,
    y: 43.5,
    style: {
      clipPath: "url(#SVGID_00000007418067729161694790000012389058631706313890_)",
      fill: "#55BBB1"
    },
    width: 17.2,
    height: 17.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054258795393097176170000010543161517851119250_)"
    }
  }, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000069368491590291619960000002263791334026257549_",
    d: "M42.5,145.8h60.9v-13.4c0-2.8-1.1-5.4-3.1-7.4 c-2-2-4.6-3.1-7.4-3.1H53c-2.8,0-5.4,1.1-7.4,3.1c-2,2-3.1,4.6-3.1,7.4V145.8z M105.3,149.6H40.6c-0.5,0-1-0.2-1.3-0.6 c-0.4-0.4-0.6-0.8-0.6-1.3v-15.3c0-3.8,1.5-7.4,4.2-10.1c2.7-2.7,6.3-4.2,10.1-4.2h39.9c3.8,0,7.4,1.5,10.1,4.2 c2.7,2.7,4.2,6.3,4.2,10.1v15.3c0,0.5-0.2,1-0.6,1.3C106.3,149.4,105.8,149.6,105.3,149.6L105.3,149.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148649210848797123200000000137102014084935844_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069368491590291619960000002263791334026257549_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000148649210848797123200000000137102014084935844_)"
    }
  }, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000183227905190950951150000008331223106367139227_",
    x: 11.8,
    y: 7.6,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052785344302990598800000014191633063465796526_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183227905190950951150000008331223106367139227_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 37.7,
    y: 117.1,
    style: {
      clipPath: "url(#SVGID_00000052785344302990598800000014191633063465796526_)",
      fill: "#55BBB1"
    },
    width: 70.4,
    height: 33.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054258795393097176170000010543161517851119250_)"
    }
  }, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000034052465473669957510000000014930485650349972_",
    d: "M63.3,121.9c-0.5,0-1-0.2-1.3-0.6 c-0.4-0.4-0.6-0.8-0.6-1.3v-12c0-0.7,0.4-1.3,0.9-1.6c0.6-0.3,1.3-0.3,1.9,0c0.6,0.3,0.9,1,0.9,1.6v12c0,0.5-0.2,1-0.6,1.3 C64.3,121.7,63.8,121.9,63.3,121.9L63.3,121.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044173881053031322560000000659422761990836882_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034052465473669957510000000014930485650349972_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044173881053031322560000000659422761990836882_)"
    }
  }, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000113345817783192532760000008768030908850538928_",
    x: 11.8,
    y: 7.6,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171701308048508878160000016530217330356880785_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000113345817783192532760000008768030908850538928_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 60.4,
    y: 105,
    style: {
      clipPath: "url(#SVGID_00000171701308048508878160000016530217330356880785_)",
      fill: "#55BBB1"
    },
    width: 5.8,
    height: 17.9
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054258795393097176170000010543161517851119250_)"
    }
  }, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000046341406306428841900000017879948889177894306_",
    d: "M82.6,121.9c-0.5,0-1-0.2-1.3-0.6 c-0.4-0.4-0.6-0.8-0.6-1.3v-12c0-0.7,0.4-1.3,0.9-1.6c0.6-0.3,1.3-0.3,1.9,0c0.6,0.3,0.9,1,0.9,1.6v12c0,0.5-0.2,1-0.6,1.3 C83.6,121.7,83.1,121.9,82.6,121.9L82.6,121.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000032640286145187979060000018136648810642727314_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000046341406306428841900000017879948889177894306_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000032640286145187979060000018136648810642727314_)"
    }
  }, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000081647085926060582690000009020159894260295809_",
    x: 11.8,
    y: 7.6,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000180367630380331435950000016955909951614646718_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000081647085926060582690000009020159894260295809_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 79.7,
    y: 105,
    style: {
      clipPath: "url(#SVGID_00000180367630380331435950000016955909951614646718_)",
      fill: "#55BBB1"
    },
    width: 5.8,
    height: 17.9
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054258795393097176170000010543161517851119250_)"
    }
  }, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000102505749890440477050000017799130035756585643_",
    d: "M58.8,145.8h28.4l0-9.2H58.8L58.8,145.8z M89.1,149.6 H56.9c-0.5,0-1-0.2-1.3-0.6c-0.4-0.4-0.6-0.8-0.6-1.3v-13c0-0.5,0.2-1,0.6-1.3c0.4-0.4,0.8-0.6,1.3-0.6h32.2 c0.5,0,1,0.2,1.3,0.6c0.4,0.4,0.6,0.8,0.6,1.3v13c0,0.5-0.2,1-0.6,1.3C90.1,149.4,89.6,149.6,89.1,149.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070805791614128736660000008510448228871151500_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000102505749890440477050000017799130035756585643_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000070805791614128736660000008510448228871151500_)"
    }
  }, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000164480420546476388560000000078491549650006940_",
    x: 11.8,
    y: 7.6,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000161626449967255855210000017537039306867900862_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000164480420546476388560000000078491549650006940_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 131.8,
    style: {
      clipPath: "url(#SVGID_00000161626449967255855210000017537039306867900862_)",
      fill: "#55BBB1"
    },
    width: 38,
    height: 18.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054258795393097176170000010543161517851119250_)"
    }
  }, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000145044013313687026450000013505785350921200795_",
    d: "M125.4,53.4l-0.1,6.8l11.2,0.1l0.1-6.8 c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0H125.4z M136.5,64.1h-11.1c-1,0-2-0.4-2.7-1.1c-0.7-0.7-1.1-1.7-1.1-2.8v-6.7 c0-1,0.4-2,1.1-2.8c0.7-0.7,1.7-1.1,2.8-1.1h11.1h0c1,0,2,0.4,2.8,1.1c0.7,0.7,1.1,1.7,1.1,2.8v6.7c0,1-0.4,2-1.2,2.8 C138.6,63.7,137.6,64.1,136.5,64.1L136.5,64.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018226658910551433240000000174261189506818725_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145044013313687026450000013505785350921200795_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000018226658910551433240000000174261189506818725_)"
    }
  }, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000039115643201000694640000012758204537347076508_",
    x: 11.8,
    y: 7.6,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121250937298654741030000017304062016562378423_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039115643201000694640000012758204537347076508_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 48.6,
    style: {
      clipPath: "url(#SVGID_00000121250937298654741030000017304062016562378423_)",
      fill: "#55BBB1"
    },
    width: 20.9,
    height: 16.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054258795393097176170000010543161517851119250_)"
    }
  }, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000169555313076951122100000009533998556573071249_",
    d: "M135.8,53.4c-0.5,0-1-0.2-1.3-0.6 c-0.4-0.4-0.6-0.8-0.6-1.3v-3.7c0-1-0.6-2-1.5-2.5c-0.9-0.5-2-0.5-2.9,0c-0.9,0.5-1.5,1.5-1.5,2.5v3.7c0,0.7-0.4,1.3-0.9,1.6 c-0.6,0.3-1.3,0.3-1.9,0c-0.6-0.3-0.9-1-0.9-1.6v-3.7c0-2.4,1.3-4.6,3.4-5.8c2.1-1.2,4.6-1.2,6.7,0c2.1,1.2,3.4,3.4,3.4,5.8v3.7 c0,0.5-0.2,1-0.6,1.3C136.8,53.2,136.3,53.4,135.8,53.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105407102557611150040000017034078037750559679_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169555313076951122100000009533998556573071249_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105407102557611150040000017034078037750559679_)"
    }
  }, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000082333161932092859220000016530577371611868329_",
    x: 11.8,
    y: 7.6,
    width: 159,
    height: 159
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101825789650227392470000015336112505466601915_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000082333161932092859220000016530577371611868329_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 123.2,
    y: 39.8,
    style: {
      clipPath: "url(#SVGID_00000101825789650227392470000015336112505466601915_)",
      fill: "#55BBB1"
    },
    width: 15.4,
    height: 14.7
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRobot);
export default __webpack_public_path__ + "static/media/error-robot.e1194e464256171fc612d31beb4aac9d.svg";
export { ForwardRef as ReactComponent };